export default {

    //智慧用气管理后台首页
    "useGas.index.824943-0": "安全用气预警监控系统",
    "useGas.index.824943-1": "区域管理",
    "useGas.index.824943-2": "首页",
    "useGas.index.824943-3": "用户管理",
    "useGas.index.824943-4": "设备档案",
    "useGas.index.824943-5": "设备报警",
    "useGas.index.824943-6": "告警设备",
    "useGas.index.824943-7": "左侧菜单",
    "useGas.index.824943-8": "您可以自主选择想要查看的信息内容，点击对应的功能菜单按钮即可",


    //智慧用电大屏
    "bigScreen.index.925365-0": "进入系统",
    "bigScreen.index.925365-1": "返回",
    "bigScreen.index.925365-2": "浙江省杭州市",
    "bigScreen.index.925365-3": "全部区域",
    "bigScreen.index.925365-4": "系统操作",
    "bigScreen.index.925365-5": "请选择此功能按钮进入后台界面",
    "bigScreen.index.925365-6": "浙江省-杭州市",
    "bigScreen.index.925365-7": "时间",
    "bigScreen.index.925365-8": "编码",
    "bigScreen.index.925365-9": "名称",
    "bigScreen.index.925365-10": "类型",
    "bigScreen.index.925365-11": "状态",
    "bigScreen.index.925365-12": "位置",
    "bigScreen.index.925365-13": "在线",
    "bigScreen.index.925365-14": "离线",
    "bigScreen.index.925365-15": "用户名称",
    "bigScreen.index.925365-16": "联系电话",
    "bigScreen.index.925365-17": "单位名称",
    "bigScreen.index.925365-18": "设备状态",
    "bigScreen.index.925365-19": "微软雅黑",

    //区域管理
    "area.index.548708-0": "添加区域",
    "area.index.548708-1": "全部区域",
    "area.index.548708-2": "暂无数据",

    //选择地址
    "mods.selectArea.004625-0": "区域选择",
    "mods.selectArea.004625-1": "保存",
    "mods.selectArea.004625-2": "全部区域",
    "mods.selectArea.004625-3": "暂无数据",

    //添加地址
    "add.index.424326-0": "保存",
    "add.index.424326-1": "上级区域",
    "add.index.424326-2": "请选择区域",
    "add.index.424326-3": "新增区域",
    "add.index.424326-4": "编辑区域",


    //村
    "add.village.443671-0": "村名称",
    "add.village.443671-1": "请输入村名称",
    "add.village.443671-2": "搜索地址",
    "add.village.443671-3": "地址",
    "add.village.443671-4": "经度",
    "add.village.443671-5": "纬度",
    "add.village.443671-6": "请输入乡镇/街道名称",
    "add.village.443671-7": "经度不能为空",
    "add.village.443671-8": "纬度不能为空",

    //乡镇
    "add.town.433277-0": "乡镇/街道名称",
    "add.town.433277-1": "请输入乡镇/街道名称",
    "add.town.433277-2": "搜索地址",
    "add.town.433277-3": "地址",
    "add.town.433277-4": "经度",
    "add.town.433277-5": "纬度",
    "add.town.433277-6": "经度不能为空",
    "add.town.433277-7": "纬度不能为空",

    //添加城市
    "add.city.415013-0": "省",
    "add.city.415013-1": "请选择省份",
    "add.city.415013-2": "城市",
    "add.city.415013-3": "请选择城市",
    "add.city.415013-4": "详细地址",
    "add.city.415013-5": "请输入详细地址",
    "add.city.415013-6": "请选择省",

    //添加区域
    "add.area.404510-0": "区域名称",
    "add.area.404510-1": "请输入区域名称",
    "add.area.404510-2": "搜索地址",
    "add.area.404510-3": "地址",
    "add.area.404510-4": "经度",
    "add.area.404510-5": "纬度",
    "add.area.404510-6": "经度不能为空",
    "add.area.404510-7": "纬度不能为空",

    //设备报警首页
    "device.index.508393-0": "设备编号：",
    "device.index.508393-1": "请输入设备编号",
    "device.index.508393-2": "搜索",
    "device.index.508393-3": "导入",
    "device.index.508393-4": "全部区域",

    //设备报警--设备状态
    "status.state.640567-0": "设备名称",
    "status.state.640567-1": "在线状态",
    "status.state.640567-2": "在线",
    "status.state.640567-3": "离线",
    "status.state.640567-4": "设备地址",
    "status.state.640567-5": "联系电话",
    "status.state.640567-6": "未设置",
    "status.index.756855-0": "设备状态",
    "status.index.756855-1": "确认",

    //设备报警---设备编辑
    "edit.index.885685-0": "修改设备",
    "edit.index.885685-1": "保存",
    "edit.index.885685-2": "设备编码",
    "edit.index.885685-3": "请输入设备编码",
    "edit.index.885685-4": "设备名称",
    "edit.index.885685-5": "请输入设备名称",
    "edit.index.885685-6": "联系人",
    "edit.index.885685-7": "请输入联系人",
    "edit.index.885685-8": "联系电话",
    "edit.index.885685-9": "请输入联系电话",
    "edit.index.885685-10": "设备名称不能为空",

    //设备报警--搜索设备
    "device.device.023557-0": "手机号：",
    "device.device.023557-1": "请输入手机号",
    "device.device.023557-2": "设备编号：",
    "device.device.023557-3": "请输入设备编号",
    "device.device.023557-4": "搜索",
    "device.index.151764-0": "选择设备",
    "device.index.151764-1": "确认",
    "device.index.151764-2": "手机号：",
    "device.index.151764-3": "请输入手机号",
    "device.index.151764-4": "设备编号：",
    "device.index.151764-5": "请输入设备编号",
    "device.index.151764-6": "搜索",

    //设备告警-添加设备
    "add.index.213388-0": "导入设备",
    "add.index.213388-1": "导入",
    "add.index.213388-2": "所属用户",
    "add.index.213388-3": "请选择用户",
    "add.index.213388-4": "请选择所属用户",
    "add.index.213388-5": "请选择选择设备",

    //用户管理--首页
    "user.index.373660-0": "新增",
    "user.index.373660-1": "全部区域",

    //用户管理--选择区域
    "village.index.527052-0": "区域选择",
    "village.index.527052-1": "保存",
    "village.index.527052-2": "全部区域",
    "village.index.527052-3": "暂无数据",

    //用户管理--添加

    "add.index.733618-0": "保存",
    "add.index.733618-1": "所属区域",
    "add.index.733618-2": "请选择区域",
    "add.index.733618-3": "幢",
    "add.index.733618-4": "请输入幢",
    "add.index.733618-5": "单元",
    "add.index.733618-6": "请输入单元",
    "add.index.733618-7": "楼层",
    "add.index.733618-8": "请输入楼层",
    "add.index.733618-9": "用户号",
    "add.index.733618-10": "请输入用户号",
    "add.index.733618-11": "业主姓名",
    "add.index.733618-12": "请输入业主姓名",
    "add.index.733618-13": "业主电话",
    "add.index.733618-14": "请输入业主电话",
    "add.index.733618-15": "用户类型",
    "add.index.733618-16": "请选择用户类型",
    "add.index.733618-17": "商户",
    "add.index.733618-18": "居民",
    "add.index.733618-19": "单位名称",
    "add.index.733618-20": "请输入单位名称",
    "add.index.733618-21": "使用年限",
    "add.index.733618-22": "请输入使用年限",
    "add.index.733618-23": "区域管理员",
    "add.index.733618-24": "请输入区域管理员",
    "add.index.733618-25": "区域管理员电话",
    "add.index.733618-26": "请输入区域管理员电话",
    "add.index.733618-27": "年检状态",
    "add.index.733618-28": "请选择年检状态",
    "add.index.733618-29": "合格",
    "add.index.733618-30": "不合格",
    "add.index.733618-31": "搜索地址",
    "add.index.733618-32": "地址",
    "add.index.733618-33": "经度",
    "add.index.733618-34": "纬度",
    "add.index.733618-35": "详细地址",
    "add.index.733618-36": "请输入详细地址",
    "add.index.733618-37": "检定证书有效期",
    "add.index.733618-38": "请选择日期",
    "add.index.733618-39": "幢不能为空",
    "add.index.733618-40": "单元不能为空",
    "add.index.733618-41": "楼层不能为空",
    "add.index.733618-42": "用户号不能为空",
    "add.index.733618-43": "业主姓名不能为空",
    "add.index.733618-44": "业主电话不能为空",
    "add.index.733618-45": "单位名称不能为空",
    "add.index.733618-46": "使用年限不能为空",
    "add.index.733618-47": "区域管理员不能为空",
    "add.index.733618-48": "区域管理员电话不能为空",
    "add.index.733618-49": "详细地址不能为空",
    "add.index.733618-50": "新增用户",
    "add.index.733618-51": "编辑用户",
    "add.index.733618-52": "区域选择错误，请在区域选择至村",


    //js内字段
    //报警列表
    "alarm.columns.097043-0": "设备名称",
    "alarm.columns.097043-1": "设备编号",
    "alarm.columns.097043-2": "设备地址",
    "alarm.columns.097043-3": "在线状态",
    "alarm.columns.097043-4": "在线",
    "alarm.columns.097043-5": "离线",
    "alarm.columns.097043-6": "设备状态",
    "alarm.columns.097043-7": "合闸",
    "alarm.columns.097043-8": "分闸",
    "alarm.columns.097043-9": "用户名称",
    "alarm.columns.097043-10": "详细地址",
    "alarm.columns.097043-11": "经度",
    "alarm.columns.097043-12": "纬度",
    "alarm.columns.097043-13": "操作",
    "alarm.columns.097043-14": "查看报警",

    //地址表单
    "area.columns.127167-0": "序号",
    "area.columns.127167-1": "区域名称",
    "area.columns.127167-2": "创建人员",
    "area.columns.127167-3": "创建日期",
    "area.columns.127167-4": "操作",
    "area.columns.127167-5": "编辑",
    "area.columns.127167-6": "提示",
    "area.columns.127167-7": "是否删除",
    "area.columns.127167-8": "删除",

    //提醒表单

    "alert.columns.114421-0": "序号",
    "alert.columns.114421-1": "设备名称",
    "alert.columns.114421-2": "设备编号",
    "alert.columns.114421-3": "告警时间",
    "alert.columns.114421-4": "告警类型",
    "alert.columns.114421-5": "用户名称",
    "alert.columns.114421-6": "详细地址",
    "alert.columns.114421-7": "经度",
    "alert.columns.114421-8": "纬度",
    "alert.columns.114421-9": "操作",
    "alert.columns.114421-10": "处理",
    "alert.columns.114421-11": "误报",
    "alert.columns.114421-12": "已处理",
    "alert.columns.114421-13": "确认",

    //设备 
    //设备添加
    "add.columns.331975-0": "设备编号",
    "add.columns.331975-1": "设备名称",
    "add.columns.331975-2": "设备类型",
    "add.columns.331975-3": "微断设备",
    "add.columns.331975-4": "门锁设备",
    "add.columns.331975-5": "烟感设备",
    "add.columns.331975-6": "气感设备",
    "add.columns.331975-7": "Zigbee设备",
    "add.columns.331975-8": "监控设备",
    "add.columns.331975-9": "操作",

    //设备设备
    "device.columns.586949-0": "设备编号",
    "device.columns.586949-1": "设备名称",
    "device.columns.586949-2": "设备类型",
    "device.columns.586949-3": "微断设备",
    "device.columns.586949-4": "门锁设备",
    "device.columns.586949-5": "烟感设备",
    "device.columns.586949-6": "气感设备",
    "device.columns.586949-7": "Zigbee设备",
    "device.columns.586949-8": "监控设备",
    "device.columns.586949-9": "在线",
    "device.columns.586949-10": "离线",
    "device.columns.586949-11": "设备地址",

    //设备设备
    "device.columns.805635-0": "序号",
    "device.columns.805635-1": "设备名称",
    "device.columns.805635-2": "设备编码",
    "device.columns.805635-3": "设备状态",
    "device.columns.805635-4": "在线",
    "device.columns.805635-5": "离线",
    "device.columns.805635-6": "上次在线时间",
    "device.columns.805635-7": "上次离线时间",
    "device.columns.805635-8": "规格型号",
    "device.columns.805635-9": "额定电流",
    "device.columns.805635-10": "额定电压",
    "device.columns.805635-11": "配置功能",
    "device.columns.805635-12": "上线率",
    "device.columns.805635-13": "设备地址",
    "device.columns.805635-14": "经度",
    "device.columns.805635-15": "纬度",
    "device.columns.805635-16": "创建日期",
    "device.columns.805635-17": "操作",
    "device.columns.805635-18": "状态",
    "device.columns.805635-19": "编辑",
    "device.columns.805635-20": "提示",
    "device.columns.805635-21": "是否删除",
    "device.columns.805635-22": "删除",

    //设备用户

    "user.columns.016995-0": "序号",
    "user.columns.016995-1": "用户名称",
    "user.columns.016995-2": "单位名称",
    "user.columns.016995-3": "联系电话",
    "user.columns.016995-4": "用户类型",
    "user.columns.016995-5": "商户",
    "user.columns.016995-6": "居民",
    "user.columns.016995-7": "气体报警器个数",
    "user.columns.016995-8": "燃气电磁阀个数",
    "user.columns.016995-9": "运行状态",
    "user.columns.016995-10": "正常",
    "user.columns.016995-11": "异常",
    "user.columns.016995-12": "使用年限",
    "user.columns.016995-13": "区域管理员",
    "user.columns.016995-14": "区域管理员电话",
    "user.columns.016995-15": "年检状态",
    "user.columns.016995-16": "合格",
    "user.columns.016995-17": "不合格",
    "user.columns.016995-18": "检定证书有效期",
    "user.columns.016995-19": "操作",
    "user.columns.016995-20": "设备",
    "user.columns.016995-21": "提示",
    "user.columns.016995-22": "是否删除",
    "user.columns.016995-23": "删除"






}


// WEBPACK FOOTER //
// ./src/i18n/lang/Zh/useGas-zh.js